import Offcanvas from 'bootstrap/js/src/offcanvas';
import ScrollSpy from 'bootstrap/js/src/scrollspy';
import Collapse from 'bootstrap/js/src/collapse';
import { addScrollMarginToTarget, setupToolbar } from './toolbar.js';
import { oneEventListener } from './utils.js';

const PREF_KEY = 'user-prefers-toc-hidden'

function _setupScrollSpy(targetId) {
    const spyTarget = document.getElementById(targetId);
    if (spyTarget == null)
        return;

    const scrollSpy = new ScrollSpy(document.body, {
        target: spyTarget
    })
    oneEventListener(document.body, 'activate.bs.scrollspy', (e) => {
        const closestCollapse = e.relatedTarget.closest(`#${targetId} .collapse`);
        if (closestCollapse && !closestCollapse.classList.contains("show")) {
            closestCollapse.classList.add('no-transition');
            Collapse.getOrCreateInstance(closestCollapse, {toggle: false}).show();
            oneEventListener(closestCollapse, "shown.bs.collapse", (e) => {
                centerSidebar();
                closestCollapse.classList.remove('no-transition');
            });
        } else {
            centerSidebar();
        }
    });
}

function _setupToc() {
    const tocCollapse = document.getElementById('bookToc');
    const tocToggle = document.getElementById('tocToggle');
    if (tocCollapse == null)
        return;

    _setupScrollSpy("pageOutlineNav");

    tocCollapse.addEventListener("show.bs.collapse", () => {
        localStorage.setItem(PREF_KEY, '');
        sessionStorage.setItem(PREF_KEY, '');
    });
    tocToggle.addEventListener("click", (event) => {
        // Focus only if toc is toggled by keyboard. Event.detail is
        // the number of clicks, which is 0 when activated by
        // keyboard.
        if (event.detail == 0) {
            oneEventListener(tocCollapse, "shown.bs.collapse", (event) => {
                if (event.target == tocCollapse) {
                    tocCollapse.focus();
                }
            });
        }
    });
    tocCollapse.addEventListener("hidden.bs.collapse", (event) => {
        if (event.target == tocCollapse) {
            localStorage.setItem(PREF_KEY, 'yes');
            sessionStorage.setItem(PREF_KEY, 'yes');
            tocToggle?.focus({preventScroll: true});
        }
    });
}

function centerSidebar() {
    const sidebarContainer = document.getElementById('bookToc');
    const activePath = sidebarContainer?.querySelectorAll('.active');

    if (activePath && activePath.length > 0) {
        const sidebarActive = activePath[activePath.length - 1];
        const containerAbsTop = sidebarContainer.getBoundingClientRect().top;
        const activeAbsTop = sidebarActive.getBoundingClientRect().top;
        const activeRelTop = activeAbsTop - containerAbsTop + sidebarContainer.scrollTop
        // Calculate middle scroll position for left sidebar
        sidebarContainer.scrollTop = activeRelTop + sidebarActive.clientHeight / 2 - sidebarContainer.clientHeight / 2;
    }
}

function setupSidebar() {
    _setupToc();
    centerSidebar();
    let sidebarOffcanvasEl = document.getElementById('sidebarOffcanvas');
    if (!sidebarOffcanvasEl)
        return;

    let sidebarOffcanvas = Offcanvas.getOrCreateInstance(sidebarOffcanvasEl);
    let anchorSel = `a[href^="#"]`;
    sidebarOffcanvasEl.addEventListener('show.bs.offcanvas', () => {
        // We need to disable the sticky toolbar to ensure
        // scrolling to the target works while the offcanvas is
        // hiding.
        window.toolbarDestructor();
        // Also make sure the footer is behind
        let footer = document.querySelector(".footer");
        footer?.classList.add("footer-hidden");

        oneEventListener(sidebarOffcanvasEl, 'hidden.bs.offcanvas', () => {
            window.toolbarDestructor = setupToolbar({hideOnInit: false})
            footer.classList.remove("footer-hidden");
        })
    });
    sidebarOffcanvasEl.querySelectorAll(anchorSel).forEach((el) => {
        el.addEventListener("click", (e) => {
            const targetId = el.hash.slice(1);
            if (targetId) {
                const anchorTarget = document.getElementById(targetId);
                addScrollMarginToTarget(anchorTarget);
            }

            sidebarOffcanvas.hide();
        });
    });
}

export default setupSidebar
